import gaParams from '../../../utilities/analytics/constants';
import {gaEvent} from '../../../utilities/analytics/tracking';

export function gAUpdatePopUpBenefitShow(status) {
  gaEvent(
    gaParams.PERSONAL_DETAILS_UPDATE_POPUP_BENEFIT_SHOW.category,
    gaParams.PERSONAL_DETAILS_UPDATE_POPUP_BENEFIT_SHOW.eventType,
    status
  );
}

export function gAUpdatePopUpBenefitButtonSubmitClick(status) {
  gaEvent(
    gaParams.PERSONAL_DETAILS_UPDATE_POPUP_BENEFIT_BUTTON_CLICK_UPDATE_DETAILS.category,
    gaParams.PERSONAL_DETAILS_UPDATE_POPUP_BENEFIT_BUTTON_CLICK_UPDATE_DETAILS.eventType,
    status
  );
}

export function gAUpdatePopUpBenefitButtonAnotherTimeClick(status) {
  gaEvent(
    gaParams.PERSONAL_DETAILS_UPDATE_POPUP_BENEFIT_BUTTON_CLICK_ANOTHER_TIME.category,
    gaParams.PERSONAL_DETAILS_UPDATE_POPUP_BENEFIT_BUTTON_CLICK_ANOTHER_TIME.eventType,
    status
  );
}
export function gAUpdatePopUpAlreadyUsedBenefitShow(status) {
  gaEvent(
    gaParams.PERSONAL_DETAILS_UPDATE_POPUP_ALREADY_USED_BENEFIT_SHOW.category,
    gaParams.PERSONAL_DETAILS_UPDATE_POPUP_ALREADY_USED_BENEFIT_SHOW.eventType,
    status
  );
}
export function gAUpdatePopUpAlreadyUsedBenefitButtonSubmitClick(status) {
  gaEvent(
    gaParams.PERSONAL_DETAILS_UPDATE_POPUP_ALREADY_USED_BENEFIT_BUTTON_CLICK_UPDATE_DETAILS.category,
    gaParams.PERSONAL_DETAILS_UPDATE_POPUP_ALREADY_USED_BENEFIT_BUTTON_CLICK_UPDATE_DETAILS.eventType,
    status
  );
}
export function gAUpdatePopUpAlreadyBenefitButtonAnotherTimeClick(status) {
  gaEvent(
    gaParams.PERSONAL_DETAILS_UPDATE_POPUP_ALREADY_USED_BENEFIT_BUTTON_CLICK_ANOTHER_TIME.category,
    gaParams.PERSONAL_DETAILS_UPDATE_POPUP_ALREADY_USED_BENEFIT_BUTTON_CLICK_ANOTHER_TIME.eventType,
    status
  );
}

export function gAUpdatePopUpWithoutBenefitShow() {
  gaEvent(
    gaParams.PERSONAL_DETAILS_UPDATE_POPUP_WITHOUT_BENEFIT_SHOW.category,
    gaParams.PERSONAL_DETAILS_UPDATE_POPUP_WITHOUT_BENEFIT_SHOW.eventType,
    gaParams.PERSONAL_DETAILS_UPDATE_POPUP_WITHOUT_BENEFIT_SHOW.eventParams
  );
}

export function gAUpdatePopUpWithoutBenefitButtonSubmitClick(status) {
  gaEvent(
    gaParams.PERSONAL_DETAILS_UPDATE_POPUP_WITHOUT_BENEFIT_BUTTON_CLICK_UPDATE_DETAILS.category,
    gaParams.PERSONAL_DETAILS_UPDATE_POPUP_WITHOUT_BENEFIT_BUTTON_CLICK_UPDATE_DETAILS.eventType,
    status
  );
}
export function gAUpdatePopUpWithoutBenefitButtonAnotherTimeClick(status) {
  gaEvent(
    gaParams.PERSONAL_DETAILS_UPDATE_POPUP_WITHOUT_BENEFIT_BUTTON_CLICK_ANOTHER_TIME.category,
    gaParams.PERSONAL_DETAILS_UPDATE_POPUP_WITHOUT_BENEFIT_BUTTON_CLICK_ANOTHER_TIME.eventType,
    status
  );
}

export function gAUpdatePopUpOutOfStockBenefitShow() {
  gaEvent(
    gaParams.PERSONAL_DETAILS_UPDATE_POPUP_OUT_OF_STOCK_OUT_OF_STOCK_BENEFIT_SHOW.category,
    gaParams.PERSONAL_DETAILS_UPDATE_POPUP_OUT_OF_STOCK_OUT_OF_STOCK_BENEFIT_SHOW.eventType,
    gaParams.PERSONAL_DETAILS_UPDATE_POPUP_OUT_OF_STOCK_OUT_OF_STOCK_BENEFIT_SHOW.eventParams
  );
}

export function gAUpdatePopUpOutOfStockBenefitButtonSubmitClick(status) {
  gaEvent(
    gaParams.PERSONAL_DETAILS_UPDATE_POPUP_OUT_OF_STOCK_BENEFIT_BUTTON_CLICK_UPDATE_DETAILS.category,
    gaParams.PERSONAL_DETAILS_UPDATE_POPUP_OUT_OF_STOCK_BENEFIT_BUTTON_CLICK_UPDATE_DETAILS.eventType,
    status
  );
}
export function gAUpdatePopUpOutOfStockBenefitButtonAnotherTimeClick(status) {
  gaEvent(
    gaParams.PERSONAL_DETAILS_UPDATE_POPUP_OUT_OF_STOCK_BENEFIT_BUTTON_CLICK_ANOTHER_TIME.category,
    gaParams.PERSONAL_DETAILS_UPDATE_POPUP_OUT_OF_STOCK_BENEFIT_BUTTON_CLICK_ANOTHER_TIME.eventType,
    status
  );
}